/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import Button from 'elements/Button';

export default class BlogPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const blogPosts = [
      {
        slug: 'building-scalable-ai-applications',
        title: 'Building Scalable AI Applications with Modern Tech Stack',
        author: 'ERapid Team',
        date: 'Jan 15, 2024',
        tags: ['AI/ML', 'Technology', 'Best Practices'],
        excerpt: 'In today\'s digital landscape, building scalable AI applications requires a strategic approach to technology selection and architecture design. At ERapid Technologies, we leverage cutting-edge frameworks like TensorFlow and PyTorch to create robust AI solutions that can handle growing data volumes and user demands. This article explores best practices for architecting AI applications that scale efficiently while maintaining high performance and reliability.',
        readMore: true,
      },
      {
        slug: 'future-of-ecommerce-ai-shopping-assistants',
        title: 'The Future of E-Commerce: AI-Powered Shopping Assistants',
        author: 'ERapid Team',
        date: 'Dec 20, 2023',
        tags: ['AI', 'E-Commerce', 'Innovation'],
        excerpt: 'AI-powered shopping assistants are revolutionizing the e-commerce experience. Our SellOnChat platform demonstrates how conversational AI can enhance customer engagement, provide personalized recommendations, and streamline the purchasing process. Learn how businesses are leveraging AI to create more intuitive and efficient online shopping experiences that drive sales and customer satisfaction.',
        readMore: true,
      },
      {
        slug: 'enterprise-support-long-term-success',
        title: 'Enterprise Support: Ensuring Long-Term Success for Your Digital Solutions',
        author: 'ERapid Team',
        date: 'Nov 10, 2023',
        tags: ['Enterprise', 'Support', 'DevOps'],
        excerpt: 'Post-deployment support is crucial for the long-term success of any digital solution. ERapid Technologies offers comprehensive enterprise-grade support including 24/7 monitoring, rapid deployment of hotfixes, and extensive warranty coverage. This article discusses how proper support infrastructure can minimize downtime, ensure security, and help your business scale effectively.',
        readMore: true,
      },
      {
        slug: 'modern-web-development-react-best-practices',
        title: 'Modern Web Development: React.js Best Practices for 2024',
        author: 'ERapid Team',
        date: 'Oct 5, 2023',
        tags: ['React.js', 'Web Development', 'Frontend'],
        excerpt: 'React.js continues to evolve, and staying updated with the latest best practices is essential for building maintainable and performant applications. We share our insights on component architecture, state management, performance optimization, and testing strategies that we use in our projects. These practices have helped us deliver high-quality web applications for clients across various industries.',
        readMore: true,
      },
    ];

    const tags = [
      'AI/ML', 'React.js', 'Node.js', 'Mobile Development', 'Web Development',
      'Enterprise Solutions', 'Cloud Services', 'DevOps', 'UI/UX Design',
      'E-Commerce', 'Automation', 'Digital Transformation', 'API Development',
      'Database Design', 'Security', 'Testing', 'Best Practices',
    ];

    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-16 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                blogs
              </h1>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                Stay updated with the latest insights, trends, and news from ERapid Technologies.
              </p>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <Fade bottom>
                <div className="mb-8">
                  <h2 className="text-2xl font-semibold text-theme-blue mb-4">Tags</h2>
                  <div className="flex flex-wrap gap-2">
                    {tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm hover:bg-theme-purple/10 hover:text-theme-purple transition-colors duration-200 cursor-pointer"
                      >
                        {tag}
                        <span className="ml-2 text-gray-400">
                          (
                          {Math.floor(Math.random() * 10) + 1}
                          )
                        </span>
                      </span>
                    ))}
                  </div>
                </div>
              </Fade>

              <div className="space-y-8">
                {blogPosts.map((post) => (
                  <Fade bottom delay={200} key={post.title}>
                    <div className="bg-white rounded-xl shadow-md border border-gray-100 p-8 transform transition-all duration-300 hover:shadow-xl">
                      <div className="flex flex-wrap gap-2 mb-4">
                        {post.tags.map((tag) => (
                          <span
                            key={tag}
                            className="px-3 py-1 bg-theme-purple/10 text-theme-purple rounded-lg text-xs font-semibold"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <h3 className="text-2xl font-bold text-theme-blue mb-3">
                        {post.title}
                      </h3>
                      <div className="flex items-center text-sm text-gray-500 mb-4">
                        <span>{post.date}</span>
                        <span className="mx-2">•</span>
                        <span>
                          by
                          {' '}
                          {post.author}
                        </span>
                      </div>
                      <p className="text-gray-600 mb-6 leading-relaxed">
                        {post.excerpt}
                      </p>
                      {post.readMore && (
                        <Button
                          href={`/blog/${post.slug}`}
                          type="link"
                          className="inline-flex items-center text-theme-purple font-semibold hover:text-dark-theme-purple transition-colors duration-200"
                        >
                          Continue Reading
                          <svg className="ml-2 w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </Button>
                      )}
                    </div>
                  </Fade>
                ))}
              </div>

              <Fade bottom delay={400}>
                <div className="mt-12 text-center">
                  <div className="inline-flex gap-2">
                    <Button
                      href="#"
                      type="link"
                      className="px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:border-theme-purple hover:text-theme-purple transition-colors duration-200"
                    >
                      Previous
                    </Button>
                    <Button
                      href="#"
                      type="link"
                      className="px-4 py-2 bg-theme-purple text-white rounded-lg hover:bg-dark-theme-purple transition-colors duration-200"
                    >
                      1
                    </Button>
                    <Button
                      href="#"
                      type="link"
                      className="px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:border-theme-purple hover:text-theme-purple transition-colors duration-200"
                    >
                      2
                    </Button>
                    <Button
                      href="#"
                      type="link"
                      className="px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:border-theme-purple hover:text-theme-purple transition-colors duration-200"
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </section>

        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
